<template>
  <el-dialog title="合并" :visible.sync="viewVisible" :close-on-click-modal="false" @close="close" width="600px">
    <template slot="title" >
      <span>合并</span>
    </template>
    <div v-if="!connect" class="tip-box">
      <img
        src="@/assets/images/new_icon_waring_yellow.png"
        class="tip-box-icon"
      />
      <span style="margin-left: 24px; color: #333">未连接人群数据源</span>
    </div>
    <el-form :model="mergeForm" :rules="rules" ref="ruleForm" :disabled="isReadOnly" :label-width="formLabelWidth">
      <el-form-item label="节点名称" prop="name" style="position: relative;">
        <el-input  class="ex-input" v-model="mergeForm.name" autocomplete="off" :maxlength="50"></el-input>
        <span class="nameTips" style="color:#627085">{{getNameLength}}/50</span>
        <div class="setName" @click="setName">智能命名</div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="viewVisible = false">取 消</el-button>
      <el-button type="primary" :disabled="isReadOnly" @click="mergeSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
//合并
import mnode from "@/api/intelligentMarket/a_node";
export default {
 name: 'mergeDialog',
 props: {
   visible: {
     type: Boolean,
     default: false
   },
   nodeId: Number,
   marketingId: Number,
  'isReadOnly': {
     type: Boolean,
     default: false
   }
 },
 components:{
 },
 created() {
   //双击节点，调取接口，获取节点输入框的名字    
   mnode.getNode({nodeId: this.nodeId}).then(res => {
     if (res.code === 1 && res.data.name) {
       this.connect = res.data.isHaveParent; 
       this.mergeForm.name = res.data.name
     }
   })
 },
 computed:{
  viewVisible: {
     get: function () {
       return this.visible
     },
     set: function (newValue) {
       if (newValue) {
         this.$emit('update:visible', true)
       } else {
         this.$emit('update:visible', false)
       }
     }
   },
   getNameLength: function () {
     return this.mergeForm.name.length
   }
 },
 data () {
   return {
    connect:true,
     formLabelWidth: '80px',
     rules: {
       name: [
         { required: true, message: '请输入节点名称', trigger: 'blur' },
         { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
       ]
     },
     mergeForm: {
       name: ''
     }
   }
 },
 methods:{
   // 智能命名
   setName(){
    mnode.getAutoName(this.nodeId).then(res=>{
      console.log(res);
      if(res.code){
        this.mergeForm.name = res.data
      }else if (res.code == undefined && res.data.code === 0){
        this.$message.warning(res.data.message)
      }
    })
   },
   //确定
   mergeSubmit(){
     this.$refs.ruleForm.validate((valid)=>{
       if(valid){
          let data = this.getDataify();
          mnode.updateDetail(data).then(res=>{
             this.$message.success(res.message);
             this.viewVisible = false;
             this.$emit('change-name', data);
          })
       }
     })
   },
   //获取数据
   getDataify(){
     let formData = {}
     formData.nodeId = this.$props.nodeId;
     formData.name = this.mergeForm.name;
     return formData
   },
   //关闭
   close(){
     this.viewVisible = false;
   }
 },
}
</script>

<style lang="scss" scoped>
.setName{
  position: absolute;
  right:60px;
  top:0px;
  color: #a585ea;
  cursor: pointer;
  &:hover{
    color: #fe4d45;
  }
}
.ex-input ::v-deep .el-input__inner {
  padding-right: 130px !important;
}

.tip-box {
  padding-left: 24px;
  text-align: left;
  line-height: 21px;
  font-size: 14px;
  margin-bottom: 16px;
  color: #999999;
  background: #fffaee;
  position: relative;
  line-height: 42px;

  &-icon{
    display: inline-block;
    position: absolute;
    width: 14px;
    height: 14px;
    color: #ffffff;
    margin: 14px 4px 0 3px;
  }
}
</style>